import React, { useState } from "react";
import axios from "axios";
import "../../styles/prescriptions/prescriptionQueue.css";
import { SERVER_URL } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface ProviderProfile {
  firstName: string;
  lastName: string;
}

export interface VerifyIdButtonProps {
  isOpen: boolean;
  patientFirstName: string; // now required
  patientId: string; // now required
  providerProfile: ProviderProfile; // no longer nullable
  onClose: () => void;
}

const VerifyIdButton: React.FC<VerifyIdButtonProps> = ({
  isOpen,
  patientFirstName,
  patientId,
  providerProfile,
  onClose,
}) => {
  const token = localStorage.getItem("token");
  const initialMessage = `Hello ${patientFirstName}, please verify your ID so we can review your prescription and get started with your care\n\n-${providerProfile.firstName} ${providerProfile.lastName}, MD.`;
  const [message, setMessage] = useState<string>(initialMessage);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      let chatId: string;

      const getResponse = await axios.get(
        `${SERVER_URL}/api/message/chats?otherUserId=${patientId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (getResponse.data && getResponse.data.id) {
        chatId = getResponse.data.id;
      } else {
        const createResponse = await axios.post(
          `${SERVER_URL}/api/message/chats`,
          { otherUserId: patientId },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        chatId = createResponse.data.id;
      }

      // Send the verification message
      await axios.post(
        `${SERVER_URL}/api/message/messages`,
        { chatId, content: message },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Send the link message right after
      await axios.post(
        `${SERVER_URL}/api/message/messages`,
        { chatId, content: "https://aliviameds.com/id-verification" },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Verification message sent successfully!");
      onClose();
    } catch (error) {
      console.error("Error sending verification message:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="verify-modal-overlay">
      <div className="verify-modal-content">
        <button className="verify-close-button" onClick={onClose}>
          X
        </button>
        <h2>Request ID Verification</h2>
        <p className="verify-info">
          This will send a message to {patientFirstName} asking them to verify
          their ID.
        </p>
        <form onSubmit={handleSubmit} className="message-box-form">
          <textarea
            className="message-box-textarea"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          ></textarea>
          <button type="submit" className="send-button">
            Send Verification Request
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyIdButton;
